import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import WorkoutTitle from './components/WorkoutTitle';
import WorkoutList from './components/WorkoutList';
import WorkoutInput from './components/WorkoutInput';
import { Color } from '../../styles/common';
import { onSnapshot } from 'firebase/firestore';
import { q } from '../../services/workout.service';

function Workout() {
  const [workouts, setWorkouts] = useState([]);

  // realtime read data
  useEffect(() => {
    onSnapshot(q, snapshot => {
      const data: any = [];

      snapshot.forEach(doc => {
        data.push({
          ...doc.data(),
          id: doc.id
        });
      })

      setWorkouts(data);
    });
  }, []);

  return (
    <Container>
      <WorkoutTitle />
      <WorkoutList workouts={workouts}/>
      <WorkoutInput />
    </Container>
  )
}

export default Workout;

const Container = styled.div`
  width: 90%;
  max-width: 480px;
  height: calc(100vh - 250px); /** 100vh - header - footer */
  margin: 120px auto 20px; /** margin from header */
  border-radius: 10px;
  text-align: center;
  box-shadow: 1px 1px 5px 1px ${ Color.GRAY100 };
  overflow: hidden; /** hidden over list items */
  position: relative;
`